<template>
    <div class="line-chart">
		<h5 class="chart-title" v-if="chartTitle">
			{{ chartTitle }}
		</h5>

        <section class="chart-container">
            <canvas :id="uniqueId" height="250" width="790"/>
        </section>
    </div>
</template>

<script>
import Chart from 'chart.js'

export default {
	props: {
		chartTitle: {
			type: String,
			default: ''
		},

		dataType: {
			type: String,
			default: ''
		},

		labels: {
			type: Array,
			default: () => []
		},

		dataSet: {
			type: Array,
			default: () => []
		},

		yAxisLabels: {
			type: Array,
			default: () => []
		},

		xAxisLabels: {
			type: Array,
			default: () => []
		}
	},

	data () {
		return {
			uniqueId: ''
		}
	},

	created () {
		this.generateUniqueId()
	},

	mounted () {
		this.renderLineChart()
	},

	methods: {
		/* Created Methods */
		generateUniqueId () {
			this.uniqueId = Math.random().toString(36).substr(2, 9)
		},

		/* Mounted Methods */
		renderLineChart () {
			const lineChartCanvas = document.getElementById(this.uniqueId)

			const data = this.setData()
			const options = this.setOptions()

			Chart.defaults.global.defaultFontColor = '#4A4C50'

			// eslint-disable-next-line
			const radarChart = new Chart(
				lineChartCanvas,
				{
					type: 'line',
					data: data,
					options: options
				}
			)
		},

		/* Set Data Methods */
		setData () {
			const data = {
				labels: this.xAxisLabels,

				datasets: [
					{
						data: this.dataSet,
						borderColor: '#61DBFF',
						backgroundColor: 'rgba(177, 237, 255, 0.4)',
						pointBackgroundColor: 'rgba(62, 207, 250, 0.5)',
						fill: true
					}
				]
			}

			return data
		},

		/* Set Option Methods */
		setOptions () {
			const option = {
				legend: {
					display: false
				},

				animation: {
					duration: 0
				},

				hover: {
					animationDuration: 0
				},

				responsiveAnimationDuration: 0,

				responsive: false,

				tooltips: {
					enabled: false
				},

				scales: this.setScales()
			}

			return option
		},

		setScales () {
			const scales = {
				xAxes: [{
					display: true,

					ticks: {
						maxRotation: 45,

						minRotation: 45
					}
				}],

				yAxes: [{
					display: true,

					ticks: {
						min: 0,

						max: 11,

						stepSize: 1,

						suggestedMin: 0.5,

						suggestedMax: 5.5,

						callback: this.setYaxisLabel
					},

					gridLines: {
						display: true
					}
				}]
			}

			scales.yAxes[0].ticks.max = this.yAxisLabels.length - 1

			return scales
		},

		setYaxisLabel (label, index, labels) {
			return this.yAxisLabels[label]
		}
	}
}
</script>

<style lang="scss" scoped>
.line-chart {
	margin-bottom: 15px;

	.chart-title {
		margin-bottom: 15px;
		padding-left: 15px;
		font-size: 13px;
	}

    .chart-container {
        width: 100%;
        margin: 0 auto;
    }
}
</style>
